/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { GALLERY_UPDATE_CARET_VISIBLE, GALLERY_UPDATE_GHOST_MODE } from './galleryscreen.types';

export const updateGalleryCaretVisibilityAction = (isCaretVisible: boolean) => ({
    type: GALLERY_UPDATE_CARET_VISIBLE,
    payload: { isCaretVisible },
});

export const setGalleryGhostModeAction = (id: string, ghostMode: boolean) => ({
    type: GALLERY_UPDATE_GHOST_MODE,
    payload: {
        id,
        ghostMode,
    },
});
